import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { utils, withTheme } from '@rjsf/core';
import { Button, Form, ButtonGroup, Alert, InputGroup } from 'react-bootstrap';
import * as React from 'react';
import React__default, { useRef, useEffect, createRef, useState, useCallback, forwardRef, useImperativeHandle, memo } from 'react';
import classNames from 'classnames';
import { NumericFormat } from 'react-number-format';
import dayjs from 'dayjs';
import RcPicker from 'rc-picker';
import zhCN from 'rc-picker/es/locale/zh_CN';
import 'dayjs/locale/zh-cn';
import dayjsGenerateConfig from 'rc-picker/es/generate/dayjs';
import 'rc-picker/assets/index.css';
import styled, { css } from 'styled-components';
import * as path from 'path';
import isEqual from 'react-fast-compare';

var _path$5;
function _extends$5() { _extends$5 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }
const SvgDash = props => /*#__PURE__*/React.createElement("svg", _extends$5({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "currentColor",
  className: "dash_svg__bi dash_svg__bi-dash"
}, props), _path$5 || (_path$5 = /*#__PURE__*/React.createElement("path", {
  d: "M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"
})));

var _path$4;
function _extends$4() { _extends$4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
const SvgPlus = props => /*#__PURE__*/React.createElement("svg", _extends$4({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "currentColor",
  className: "plus_svg__bi plus_svg__bi-plus"
}, props), _path$4 || (_path$4 = /*#__PURE__*/React.createElement("path", {
  d: "M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"
})));

var _path$3;
function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
const SvgArrowUp = props => /*#__PURE__*/React.createElement("svg", _extends$3({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "currentColor",
  className: "arrow-up_svg__bi arrow-up_svg__bi-arrow-up"
}, props), _path$3 || (_path$3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z"
})));

var _path$2;
function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
const SvgArrowDown = props => /*#__PURE__*/React.createElement("svg", _extends$2({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "currentColor",
  className: "arrow-down_svg__bi arrow-down_svg__bi-arrow-down"
}, props), _path$2 || (_path$2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"
})));

const mappings = {
  remove: jsx(SvgDash, {}),
  plus: jsx(SvgPlus, {}),
  arrowUp: jsx(SvgArrowUp, {}),
  arrowDown: jsx(SvgArrowDown, {})
};
function IconButton(props) {
  const {
    icon,
    className,
    ...otherProps
  } = props;
  return jsx(Button, {
    ...otherProps,
    variant: 'light',
    size: 'sm',
    children: mappings[icon]
  });
}

function FieldTemplate(props) {
  const {
    id,
    children,
    displayLabel,
    rawErrors = [],
    label,
    schema,
    required,
    onDropPropertyClick,
    onKeyChange,
    hidden,
    uiSchema,
    formContext
  } = props;
  if (hidden) {
    return jsx("div", {
      className: 'd-none',
      children: children
    });
  }
  const description = uiSchema['ui:description'] || props.schema.description || schema.description;
  const help = uiSchema['ui:help'];
  const {
    layout = 'vertical'
  } = formContext;
  const {
    col = 12,
    labelCol = 2
  } = utils.getUiOptions(uiSchema) || {};
  const horizontal = layout === 'horizontal' && displayLabel;
  let field = jsxs(Fragment, {
    children: [children, displayLabel && description ? typeof description === 'string' ? jsx(Form.Text, {
      muted: true,
      dangerouslySetInnerHTML: {
        __html: description
      }
    }) : jsx(Form.Text, {
      muted: true,
      children: description
    }) : null, rawErrors.length > 0 && rawErrors.map((error, index) => {
      return jsx(Form.Control.Feedback, {
        type: 'invalid',
        children: error
      }, index);
    }), help && (typeof help === 'string' ? jsx(Form.Text, {
      muted: true,
      dangerouslySetInnerHTML: {
        __html: help
      }
    }) : jsx(Form.Text, {
      muted: true,
      children: help
    }))]
  });
  if (horizontal) {
    field = jsx("div", {
      className: 'col',
      children: field
    });
  }
  if (displayLabel) {
    field = jsxs(Fragment, {
      children: [jsxs(Form.Label, {
        className: classNames({
          [`col-${labelCol} col-form-label text-end me-3`]: horizontal
        }),
        children: [label || schema.title, required ? jsx("span", {
          className: 'text-danger',
          children: "*"
        }) : null]
      }), field]
    });
  }
  const additional = schema.hasOwnProperty(utils.ADDITIONAL_PROPERTY_FLAG);
  if (!additional) {
    return jsx("div", {
      className: classNames('col-12', `col-md-${col}`, {
        'd-flex': horizontal
      }),
      children: field
    });
  }
  const keyLabel = `${label} Key`;
  return jsx("div", {
    className: 'col-12',
    children: jsxs("div", {
      className: 'row g-3',
      children: [jsxs("div", {
        className: 'col-2',
        children: [displayLabel && jsx(Form.Label, {
          children: keyLabel
        }), jsx(Form.Control, {
          type: 'text',
          id: `${id}-key`,
          onBlur: event => onKeyChange(event.target.value),
          defaultValue: label
        })]
      }), jsx("div", {
        className: 'col-10',
        children: jsxs("div", {
          className: 'd-flex flex-nowrap align-items-start',
          children: [jsx("div", {
            className: 'flex-fill me-3',
            children: field
          }), jsx(IconButton, {
            icon: 'remove',
            disabled: props.disabled || props.readonly,
            onClick: onDropPropertyClick(props.label)
          })]
        })
      })]
    })
  });
}

function Fieldset(props) {
  const {
    TitleField,
    DescriptionField,
    required,
    schema,
    uiSchema,
    idSchema,
    formContext,
    title,
    children,
    className = ''
  } = props;
  const {
    label: displayLabel = true,
    labelCol = 2,
    title: label = title,
    description = schema.description
  } = utils.getUiOptions(uiSchema) || {};
  const {
    layout = 'vertical'
  } = formContext;
  const horizontal = layout === 'horizontal' && displayLabel;
  if (horizontal) {
    return jsxs("div", {
      className: 'd-flex',
      children: [jsxs(Form.Label, {
        className: classNames({
          [`col-${labelCol} col-form-label text-end me-3`]: horizontal
        }),
        children: [label, required ? jsx("span", {
          className: 'text-danger',
          children: "*"
        }) : null]
      }), jsxs("fieldset", {
        className: 'col border rounded p-3',
        children: [description && jsx(DescriptionField, {
          id: `${idSchema.$id}-description`,
          description: description
        }), children]
      })]
    });
  }
  return jsxs("fieldset", {
    className: `border rounded p-3 ${className}`,
    children: [label && jsx(TitleField, {
      id: `${idSchema.$id}-title`,
      title: label,
      required: required
    }), description && jsx(DescriptionField, {
      id: `${idSchema.$id}-description`,
      description: description
    }), children]
  });
}

const {
  canExpand
} = utils;
function ObjectFieldTemplate(props) {
  const {
    properties,
    uiSchema,
    idSchema,
    schema,
    formData,
    onAddClick,
    disabled,
    readonly
  } = props;
  const isRoot = idSchema.$id === 'root';
  const {
    label: displayLabel = true
  } = utils.getUiOptions(uiSchema) || {};
  let fields = jsxs("div", {
    className: 'row g-3',
    children: [properties.map(element => element.content), canExpand(schema, uiSchema, formData) && jsx("div", {
      className: 'col-12',
      children: jsx(IconButton, {
        icon: 'plus',
        onClick: onAddClick(schema),
        disabled: disabled || readonly
      })
    })]
  });
  if (isRoot || !displayLabel) {
    return fields;
  }
  return jsx(Fieldset, {
    ...props,
    children: fields
  });
}

const {
  isFixedItems
} = utils;
function ArrayFieldTemplate(props) {
  const {
    schema
  } = props;
  if (isFixedItems(schema)) {
    return jsx(DefaultFixedArrayFieldTemplate, {
      ...props
    });
  }
  return jsx(DefaultNormalArrayFieldTemplate, {
    ...props
  });
}
const DefaultArrayItem = props => {
  return jsx("div", {
    className: 'col-12',
    children: jsxs("div", {
      className: 'd-flex flex-nowrap align-items-start',
      children: [jsx("div", {
        className: 'flex-fill me-3',
        children: props.children
      }), props.hasToolbar && jsxs(ButtonGroup, {
        children: [(props.hasMoveUp || props.hasMoveDown) && jsx(IconButton, {
          icon: 'arrowUp',
          tabIndex: -1,
          disabled: props.disabled || props.readonly || !props.hasMoveUp,
          onClick: props.onReorderClick(props.index, props.index - 1)
        }), (props.hasMoveUp || props.hasMoveDown) && jsx(IconButton, {
          icon: 'arrowDown',
          tabIndex: -1,
          disabled: props.disabled || props.readonly || !props.hasMoveDown,
          onClick: props.onReorderClick(props.index, props.index + 1)
        }), props.hasRemove && jsx(IconButton, {
          icon: 'remove',
          tabIndex: -1,
          disabled: props.disabled || props.readonly,
          onClick: props.onDropIndexClick(props.index)
        })]
      })]
    })
  }, props.key);
};
const DefaultNormalArrayFieldTemplate = props => {
  const isRoot = props.idSchema.$id === 'root';
  const fields = jsxs("div", {
    className: 'row g-3',
    children: [props.items && props.items.map(p => DefaultArrayItem(p)), props.canAdd && jsx("div", {
      className: 'col-12',
      children: jsx(IconButton, {
        icon: 'plus',
        onClick: props.onAddClick,
        disabled: props.disabled || props.readonly
      })
    })]
  });
  if (isRoot) {
    return fields;
  }
  return jsx(Fieldset, {
    ...props,
    children: fields
  });
};
const DefaultFixedArrayFieldTemplate = props => {
  const {
    idSchema
  } = props;
  const isRoot = idSchema.$id === 'root';
  const fields = jsxs("div", {
    className: 'row g-3',
    children: [props.items && props.items.map(p => DefaultArrayItem(p)), props.canAdd && jsx("div", {
      className: 'col-12',
      children: jsx(IconButton, {
        icon: 'plus',
        onClick: props.onAddClick,
        disabled: props.disabled || props.readonly
      })
    })]
  });
  if (isRoot) {
    return fields;
  }
  return jsx(Fieldset, {
    ...props,
    children: fields
  });
};

function ErrorList(_ref) {
  let {
    errorSchema
  } = _ref;
  let errors;
  if ('__errors' in errorSchema) {
    errors = [errorSchema.__errors.join('')];
  } else {
    errors = Object.values(errorSchema).map(e => e.__errors.join(''));
  }
  return jsx("div", {
    className: 'col-12',
    children: jsx(Alert, {
      className: 'mb-0',
      variant: 'danger',
      children: jsx("ul", {
        className: 'mb-0',
        children: errors.map((error, i) => {
          return jsx("li", {
            children: error
          }, i);
        })
      })
    })
  });
}

function DescriptionField(_ref) {
  let {
    description
  } = _ref;
  if (description) {
    return jsx("div", {
      className: 'text-muted mb-3',
      children: jsx("small", {
        children: description
      })
    });
  }
  return null;
}

function TitleField(_ref) {
  let {
    title,
    required
  } = _ref;
  return jsxs("legend", {
    className: 'float-none w-auto fs-6 px-2 mb-0',
    children: [title, required && jsx("span", {
      children: "*"
    })]
  });
}

const registry$1 = utils.getDefaultRegistry();
const fields = {
  ...registry$1.fields,
  DescriptionField,
  TitleField
};

function CheckboxWidget(props) {
  const {
    id,
    value,
    required,
    disabled,
    readonly,
    label,
    schema,
    autofocus,
    onChange,
    onBlur,
    onFocus,
    rawErrors = [],
    formContext
  } = props;
  const {
    layout = 'vertical'
  } = formContext;
  const _onChange = _ref => {
    let {
      target: {
        checked
      }
    } = _ref;
    return onChange(checked);
  };
  const _onBlur = _ref2 => {
    let {
      target: {
        checked
      }
    } = _ref2;
    return onBlur(id, checked);
  };
  const _onFocus = _ref3 => {
    let {
      target: {
        checked
      }
    } = _ref3;
    return onFocus(id, checked);
  };
  return jsxs(Form.Check, {
    id: id,
    label: label,
    required: required,
    type: 'switch',
    className: 'py-2 mb-0',
    children: [jsx(Form.Check.Input, {
      autoFocus: autofocus,
      onChange: _onChange,
      onBlur: _onBlur,
      onFocus: _onFocus,
      disabled: disabled || readonly,
      required: required,
      checked: typeof value === 'undefined' ? false : value,
      type: 'checkbox',
      isInvalid: rawErrors.length > 0
    }), layout === 'vertical' && jsx(Form.Check.Label, {
      title: '',
      children: label
    }), schema.description && jsx(Form.Text, {
      muted: true,
      as: 'div',
      dangerouslySetInnerHTML: {
        __html: schema.description
      }
    })]
  });
}

const {
  asNumber,
  guessType,
  getUiOptions: getUiOptions$1
} = utils;
const nums = new Set(['number', 'integer']);
function processValue(schema, value) {
  // "enum" is a reserved word, so only "type" and "items" can be destructured
  const {
    type,
    items
  } = schema;
  if (value === '') {
    return undefined;
    // @ts-ignore
  } else if (type === 'array' && items && nums.has(items.type)) {
    return value.map(asNumber);
  } else if (type === 'boolean') {
    return value === 'true';
  } else if (type === 'number') {
    return asNumber(value);
  } else if (type === 'string' && Array.isArray(value)) {
    return value.join(',');
  }
  // If type is undefined, but an enum is present, try and infer the type from
  // the enum values
  if (schema.enum) {
    if (schema.enum.every(x => guessType(x) === 'number')) {
      return asNumber(value);
    } else if (schema.enum.every(x => guessType(x) === 'boolean')) {
      return value === 'true';
    }
  }
  return value;
}
function getEnumOptions(props) {
  let enumOptions = props.options.enumOptions;
  if (!enumOptions) {
    const uiOptions = getUiOptions$1(props.uiSchema);
    enumOptions = uiOptions?.enumOptions || [];
  }
  return enumOptions;
}

function selectValue(value, selected, all) {
  const at = all.indexOf(value);
  const updated = selected.slice(0, at).concat(value, selected.slice(at));
  // As inserting values at predefined index positions doesn't work with empty
  // arrays, we need to reorder the updated selection to match the initial order
  return updated.sort((a, b) => all.indexOf(a) - all.indexOf(b));
}
function deselectValue(value, selected) {
  return selected.filter(v => v !== value);
}
function CheckboxesWidget(props) {
  const {
    id,
    disabled,
    options,
    value,
    autofocus,
    readonly,
    onChange,
    onBlur,
    onFocus,
    required,
    rawErrors = []
  } = props;
  const enumOptions = getEnumOptions(props);
  const {
    enumDisabled = [],
    enumDescriptions = [],
    enumNames = [],
    inline
  } = options;
  const _onChange = option => _ref => {
    let {
      target: {
        checked
      }
    } = _ref;
    const all = enumOptions.map(_ref2 => {
      let {
        value
      } = _ref2;
      return value;
    });
    if (checked) {
      onChange(selectValue(option.value, value, all));
    } else {
      onChange(deselectValue(option.value, value));
    }
  };
  const _onBlur = _ref3 => {
    let {
      target: {
        value
      }
    } = _ref3;
    return onBlur(id, value);
  };
  const _onFocus = _ref4 => {
    let {
      target: {
        value
      }
    } = _ref4;
    return onFocus(id, value);
  };
  return jsx("div", {
    id: id,
    children: enumOptions.map((option, index) => {
      const checked = value.indexOf(option.value) !== -1;
      const itemDisabled = enumDisabled.indexOf(option.value) != -1;
      const label = enumNames[index] || option.label;
      const description = enumDescriptions[index];
      return jsxs(Form.Check, {
        inline: inline,
        id: `${id}_${index}`,
        label: label,
        children: [jsx(Form.Check.Input, {
          autoFocus: autofocus && index === 0,
          onChange: _onChange(option),
          onBlur: _onBlur,
          onFocus: _onFocus,
          disabled: disabled || itemDisabled || readonly,
          required: required,
          checked: checked,
          type: 'checkbox',
          isInvalid: rawErrors.length > 0
        }), jsx(Form.Check.Label, {
          children: label
        }), description && !inline && jsx(Form.Text, {
          className: 'mb-2',
          muted: true,
          as: 'div',
          dangerouslySetInnerHTML: {
            __html: description
          }
        })]
      }, `${id}_${index}`);
    })
  });
}

function TextareaWidget(_ref) {
  let {
    id,
    placeholder,
    required,
    readonly,
    disabled,
    value,
    onChange,
    onBlur,
    onFocus,
    autofocus,
    options,
    rawErrors = []
  } = _ref;
  const {
    rows
  } = options;
  const _onChange = _ref2 => {
    let {
      target: {
        value
      }
    } = _ref2;
    return onChange(value === '' ? options.emptyValue : value);
  };
  const _onBlur = _ref3 => {
    let {
      target: {
        value
      }
    } = _ref3;
    return onBlur(id, value);
  };
  const _onFocus = _ref4 => {
    let {
      target: {
        value
      }
    } = _ref4;
    return onFocus(id, value);
  };
  return jsx(Fragment, {
    children: jsx(Form.Control, {
      id: id,
      as: 'textarea',
      placeholder: placeholder,
      autoFocus: autofocus,
      required: required,
      disabled: disabled,
      readOnly: readonly,
      isInvalid: rawErrors.length > 0,
      value: value || value === 0 ? value : '',
      onChange: _onChange,
      onBlur: _onBlur,
      onFocus: _onFocus,
      rows: rows
    })
  });
}

function getValue(event, multiple) {
  if (multiple) {
    return [].slice.call(event.target.options).filter(o => o.selected).map(o => o.value);
  } else {
    return event.target.value;
  }
}
function SelectWidget(props) {
  const {
    schema,
    id,
    options,
    value,
    required,
    disabled,
    readonly,
    multiple,
    autofocus,
    onChange,
    onBlur,
    onFocus,
    placeholder
  } = props;
  const enumOptions = getEnumOptions(props);
  const {
    enumDisabled = [],
    enumNames = []
  } = options;
  const emptyValue = multiple ? [] : '';
  return jsxs(Form.Select, {
    id: id,
    multiple: multiple,
    value: typeof value === 'undefined' ? emptyValue : value,
    required: required,
    disabled: disabled || readonly,
    autoFocus: autofocus,
    onBlur: onBlur && (event => {
      const newValue = getValue(event, multiple);
      onBlur(id, processValue(schema, newValue));
    }),
    onFocus: onFocus && (event => {
      const newValue = getValue(event, multiple);
      onFocus(id, processValue(schema, newValue));
    }),
    onChange: event => {
      const newValue = getValue(event, multiple);
      onChange(processValue(schema, newValue));
    },
    children: [!multiple && schema.default === undefined && jsx("option", {
      value: '',
      children: placeholder
    }), enumOptions.map((_ref, i) => {
      let {
        value,
        label
      } = _ref;
      const disabled = enumDisabled.indexOf(value) != -1;
      return jsx("option", {
        value: value,
        disabled: disabled,
        children: enumNames[i] || label
      }, i);
    })]
  });
}

const BaseInput = _ref => {
  let {
    id,
    placeholder,
    required,
    readonly,
    disabled,
    type,
    value,
    onChange,
    onBlur,
    onFocus,
    autofocus,
    autoComplete,
    options,
    schema,
    rawErrors = []
  } = _ref;
  const _onChange = _ref2 => {
    let {
      target: {
        value
      }
    } = _ref2;
    return onChange(value === '' ? options.emptyValue : value);
  };
  const _onBlur = _ref3 => {
    let {
      target: {
        value
      }
    } = _ref3;
    return onBlur(id, value);
  };
  const _onFocus = _ref4 => {
    let {
      target: {
        value
      }
    } = _ref4;
    return onFocus(id, value);
  };
  const inputType = (type || schema.type) === 'string' ? 'text' : `${type || schema.type}`;
  const format = schema.format || options.format;
  const {
    prefix,
    suffix
  } = options;
  const inputProps = {};
  if (typeof schema.minimum !== 'undefined') {
    inputProps.min = schema.minimum;
  }
  if (typeof schema.maximum !== 'undefined') {
    inputProps.max = schema.maximum;
  }
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current && autofocus) {
      ref.current.focus();
    }
  }, []);
  let input;
  if (format === 'currency') {
    input = jsx(NumericFormat, {
      id: id,
      placeholder: placeholder || '请输入',
      autoFocus: autofocus,
      required: required,
      disabled: disabled,
      readOnly: readonly,
      isInvalid: rawErrors.length > 0,
      value: value || value === 0 ? value : '',
      onBlur: _onBlur,
      onFocus: _onFocus,
      autoComplete: autoComplete,
      ...inputProps,
      //
      customInput: Form.Control,
      decimalScale: 2,
      allowNegative: false,
      thousandSeparator: ',',
      fixedDecimalScale: true,
      onValueChange: _ref5 => {
        let {
          value
        } = _ref5;
        onChange(value);
      }
    });
  } else {
    input = jsx(Form.Control, {
      ref: ref,
      id: id,
      placeholder: placeholder || '请输入',
      autoFocus: autofocus,
      required: required,
      disabled: disabled,
      readOnly: readonly,
      isInvalid: rawErrors.length > 0,
      autoComplete: autoComplete,
      type: inputType,
      value: value || value === 0 ? value : '',
      onChange: _onChange,
      onBlur: _onBlur,
      onFocus: _onFocus,
      ...inputProps
    });
  }
  if (prefix || suffix) {
    return jsxs(InputGroup, {
      children: [prefix && jsx(InputGroup.Text, {
        children: prefix
      }), input, suffix && jsx(InputGroup.Text, {
        children: suffix
      })]
    });
  }
  return input;
};

const Container$2 = styled.div`
    width: 100%;

    .rc-picker {
        display: flex;
        border: 1px solid #d9d9d9;
        padding: 0.375rem 0.75rem;
        border-radius: 0.375rem;
        position: relative;

        .rc-picker-input {
            display: inline-flex;
            align-items: center;
            position: static;

            & > input {
                position: relative;
                display: inline-block;
                width: 100%;
                min-width: 1px;
                padding: 0;
                font-size: 14px;
                line-height: 1.5714285714285714;
                border-radius: 0;
                flex: auto;
                height: auto;
                background: #fff none 0 0;
                border: 0;
                outline: 0;

                &::placeholder {
                    color: #6c757d;
                    opacity: 1;
                }
            }
        }
    }

    .rc-picker-suffix {
        display: flex;
        flex: none;
        align-self: center;
        margin-left: 4px;
        color: rgba(0, 0, 0, .4);
        line-height: 1;
        pointer-events: none;
    }

    .rc-picker-focused {
        color: #212529;
        background-color: #fff;
        border-color: #9eb0ff;
        outline: 0;
        box-shadow: 0 0 0 0.25rem rgba(60, 96, 255, 0.25);
    }

    .rc-picker-clear {
        top: 6px;
        right: 6px;
        background: #FFFFFF;
    }

    .rc-picker-dropdown {
        z-index: 1000;
        box-shadow: none;

        .rc-picker-range-arrow {
            display: none;
        }

        .rc-picker-panel-container {
            box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
            border-radius: 0.375rem;
            overflow: hidden;
            background: #FFFFFF;

            .rc-picker-panels {
                display: inline-flex;
                flex-wrap: nowrap;
            }

            .rc-picker-presets {
                display: flex;
                flex-direction: column;
                min-width: 120px;
                max-width: 200px;
                background: #fff;

                ul {
                    height: 0;
                    flex: auto;
                    overflow: auto;
                    padding: 8px;
                    border-right: 1px solid var(--bs-border-color);

                    li {
                        height: 30px;
                        line-height: 30px;
                        padding: 0 8px;
                        border-radius: 4px;
                        cursor: pointer;

                        &:hover {
                            background: #eee;
                        }
                    }
                }
            }
        }
    }

    .rc-picker-dropdown-range {
        padding: 0;
    }

    .rc-picker-panel {
        background: #FFFFFF;
        border: none;
        display: inline-flex;
        flex-direction: column;
    }

    .rc-picker-body {
        padding: 8px 18px
    }

    .rc-picker-date-panel {
        .rc-picker-content {
            width: 252px;

            th {
                line-height: 30px;
            }
        }
    }

    .rc-picker-cell-inner {
        height: 30px;
        line-height: 30px;
        border-radius: 4px;
        padding: 0 6px;
        font-size: 1rem;

        &:hover {
            background: #eee;
        }
    }

    .rc-picker-date-panel .rc-picker-cell-inner {
        width: 30px;
        padding: 0;
    }

    .rc-picker-cell-today > .rc-picker-cell-inner {
        border-color: var(--bs-primary);
        line-height: 28px;
    }

    .rc-picker-header {
        border-bottom: 1px solid var(--bs-border-color);
        padding: 8px;
    }

    .rc-picker-footer {
        border-top: 1px solid var(--bs-border-color);
        background: #fff;
        padding: 8px;
        text-align: center;
    }

    .rc-picker-header-view {
        line-height: 30px;
        font-weight: bold;
    }

    .rc-picker-cell-range-start > .rc-picker-cell-inner,
    .rc-picker-cell-range-end > .rc-picker-cell-inner,
    .rc-picker-cell-selected > .rc-picker-cell-inner {
        background: var(--bs-primary);
        color: #fff;

        &:hover {
            background: var(--bs-link-hover-color);
        }
    }

    .rc-picker-header-super-prev-btn,
    .rc-picker-header-super-next-btn,
    .rc-picker-header-prev-btn,
    .rc-picker-header-next-btn {
        border: none;
        outline: none;
        width: 30px;
        height: 30px;
        line-height: 30px;
        background: none;
        border-radius: 4px;
        padding: 0;
        font-weight: bold;
        text-align: center;

        &:hover {
            background: #eee;
        }
    }

    .rc-picker-year-btn,
    .rc-picker-decade-btn,
    .rc-picker-month-btn {
        height: 30px;
        line-height: 30px;
        border: none;
        outline: none;
        background: none;
        padding: 0 6px;
        text-align: center;
        border-radius: 4px;
        font-weight: bold;

        &:hover {
            background: #eee;
        }
    }

    .rc-picker-datetime-panel .rc-picker-time-panel {
        border-left-color: var(--bs-border-color);
    }

    .rc-picker-time-panel-column {
        font-size: 1rem;
        flex: 1 0 auto;
        width: 56px;
        margin: 4px 0;
        padding: 0;

        & > li {
            margin-inline: 4px;

            &.rc-picker-time-panel-cell-selected {
                .rc-picker-time-panel-cell-inner {
                    background: var(--bs-primary);
                    color: #ffffff;
                }
            }

            .rc-picker-time-panel-cell-inner {
                width: 48px;
                height: 28px;
                padding: 0 0 0 14px;
                line-height: 28px;
                border-radius: 4px;
                cursor: pointer;
                transition: background .2s;

                &:hover {
                    background: #eee;
                }
            }
        }

        &:not(:first-child) {
            border-inline-start: 1px solid var(--bs-border-color);
        }
    }

    .rc-picker-time-panel .rc-picker-content {
        height: 224px;
        flex: auto;
        max-height: inherit;
    }

    .rc-picker-ranges {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .rc-picker-today-btn,
    .rc-picker-now-btn {
        cursor: pointer;
        padding: 0 8px;
        color: var(--bs-primary);

        &:hover {
            color: var(--bs-link-hover-color);
        }
    }

    .rc-picker-range {
        .rc-picker-active-bar {
            background: var(--bs-primary);
            height: 2px;
            bottom: -1px;
            margin-inline-start: 10px;
        }
    }

    .rc-picker-range-separator {
        padding: 0 8px;
    }

    .rc-picker-cell-range-hover-start::after,
    .rc-picker-cell-range-hover-end::after,
    .rc-picker-cell-range-hover::after {
        position: absolute;
        top: 1px;
        right: 1px;
        bottom: 1px;
        left: 1px;
        border: 1px dashed var(--bs-primary);
        border-right: 0;
        border-left: 0;
        content: '';
        pointer-events: none;
    }

    .rc-picker-cell-range-hover-start::after {
        border-left: 1px dashed var(--bs-primary) !important;
        border-bottom-left-radius: 4px;
        border-top-left-radius: 4px;
        left: 3px;
    }

    .rc-picker-cell-range-hover-end::after {
        border-right: 1px dashed var(--bs-primary) !important;
        border-bottom-right-radius: 4px;
        border-top-right-radius: 4px;
        right: 3px;
    }

    .rc-picker-cell-hover > .rc-picker-cell-inner {
        background: rgba(var(--bs-primary-rgb), .8);
        color: #FFFFFF;
    }
`;

function Picker(props) {
  const ref = createRef();
  return jsx(Container$2, {
    ref: ref,
    children: jsx(RcPicker, {
      ...props,
      locale: zhCN,
      suffixIcon: jsx("i", {
        className: 'bi bi-calendar3'
      }),
      components: {
        button: function (props) {
          return jsx(Button, {
            ...props,
            size: 'sm',
            type: 'button'
          });
        }
      },
      getPopupContainer: () => ref.current,
      allowClear: {
        clearIcon: jsx("button", {
          className: 'btn-close'
        })
      },
      generateConfig: dayjsGenerateConfig
    })
  });
}

function getUiOptions(uiSchema) {
  return utils.getUiOptions(uiSchema) || {};
}

function TimeWidget(props) {
  const {
    value,
    onChange,
    placeholder,
    uiSchema
  } = props;
  const {
    second = true
  } = getUiOptions(uiSchema);
  const format = second ? 'HH:mm:ss' : 'HH:mm';
  return jsx(Picker, {
    showTime: {
      showSecond: second
    },
    showNow: false,
    picker: 'time',
    placeholder: placeholder,
    value: value ? dayjs(value, format) : null,
    onChange: value => {
      if (value) {
        onChange(dayjs(value).format(format));
      } else {
        onChange(null);
      }
    }
  });
}

var _path$1, _path2;
function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
const SvgUpload = props => /*#__PURE__*/React.createElement("svg", _extends$1({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  className: "upload_svg__bi upload_svg__bi-upload",
  viewBox: "0 0 16 16"
}, props), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
  d: "M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z"
})));

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgFile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  className: "file_svg__bi file_svg__bi-file-earmark",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z"
})));

const isImageUrl = function (url) {
  const extension = path.extname(url);
  if (/^data:image\//.test(url) || /(webp|svg|png|gif|jpg|jpeg|jfif|bmp|dpg|ico)$/i.test(extension)) {
    return true;
  }
  if (/^data:/.test(url)) {
    // other file types of base64
    return false;
  }
  if (extension) {
    // other file types which have extension
    return false;
  }
  return true;
};
function defaultRenderIcon(url) {
  return isImageUrl(url) ? jsx("img", {
    height: 48,
    src: url
  }) : jsx(SvgFile, {
    height: 30,
    width: 30
  });
}
function defaultTransformValue(file) {
  return file.value || file.url;
}
function UploadWidget(props) {
  const {
    options,
    disabled,
    value,
    multiple,
    onChange,
    rawErrors = []
  } = props;
  const isFirstRun = useRef(true);
  const {
    accept,
    onUpload,
    renderIcon = defaultRenderIcon,
    transformValue = defaultTransformValue,
    showFilename = true
  } = options;
  const fileRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState(() => {
    return Array.from(multiple ? value : [value]).flatMap((item, index) => {
      if (item) {
        if (typeof item === 'string') {
          return [{
            id: `image-${index}`,
            name: 'image.png',
            url: item,
            value: item
          }];
        } else if (typeof item === 'object' && 'url' in item && 'value' in item) {
          return [{
            id: `image-${index}`,
            name: 'name' in item ? item.name : 'image.png',
            url: item.url,
            value: item.value
          }];
        }
      }
      return [];
    });
  });
  const handleFileChange = useCallback(async _ref => {
    let {
      target
    } = _ref;
    if (target.files) {
      setUploading(true);
      try {
        const files = multiple ? Array.from(target.files) : Array.from(target.files).slice(0, 1);
        const nextUploadedFiles = [...(multiple ? uploadedFiles : []), ...files.map((file, index) => ({
          id: String(new Date().getTime()) + index,
          url: '',
          value: '',
          name: file.name
        }))];
        setUploadedFiles(nextUploadedFiles);
        if (onUpload) {
          for (const file of files) {
            try {
              const result = await onUpload(file);
              setUploadedFiles([...nextUploadedFiles.map(uploadedFile => {
                if (uploadedFile.name == file.name) {
                  if (typeof result === 'string') {
                    uploadedFile.url = result;
                    uploadedFile.value = result;
                  } else {
                    uploadedFile.url = result.url;
                    uploadedFile.value = result.value;
                  }
                }
                return uploadedFile;
              })]);
            } catch (e) {
              console.error(e);
            }
          }
        }
      } finally {
        setUploading(false);
      }
    }
    target.value = '';
  }, [onUpload, uploadedFiles]);
  const removeFile = id => {
    setUploadedFiles([...uploadedFiles.filter(file => file.id !== id)]);
  };
  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
    } else {
      const files = uploadedFiles.filter(file => file.value || file.url);
      if (files.length === 0) {
        multiple ? onChange([]) : onChange(null);
      } else {
        const value = multiple ? files.map(transformValue) : transformValue(files[0]);
        onChange(value);
      }
    }
  }, [uploadedFiles]);
  const className = [];
  rawErrors.length > 0 && className.push('is-invalid');
  return jsxs("div", {
    className: className.join(' '),
    children: [jsxs(Button, {
      onClick: () => fileRef.current?.click(),
      className: 'd-flex align-items-center',
      variant: 'light',
      disabled: disabled || uploading,
      children: [jsx(SvgUpload, {
        height: 16,
        width: 16,
        className: 'me-2'
      }), "\u9009\u62E9\u6587\u4EF6"]
    }), jsx("input", {
      onChange: handleFileChange,
      multiple: multiple,
      accept: accept,
      ref: fileRef,
      type: 'file',
      hidden: true
    }), uploadedFiles.map(file => {
      return jsxs("div", {
        className: 'mt-2 border border-1 rounded p-2 d-flex align-items-center',
        children: [jsx("div", {
          className: 'd-flex align-items-center justify-content-center overflow-hidden',
          style: {
            height: 50,
            minWidth: 50
          },
          children: file.url ? renderIcon(file.url) : jsx("div", {
            style: {
              width: 30,
              height: 30
            },
            className: 'spinner-border text-secondary',
            role: 'status',
            children: jsx("span", {
              className: 'visually-hidden',
              children: "Loading..."
            })
          })
        }), jsx("span", {
          className: 'flex-fill ms-2 text-truncate',
          children: showFilename ? file.name : ''
        }), jsx("button", {
          onClick: () => removeFile(file.id),
          type: 'button',
          className: 'btn-close ms-2 flex-shrink-0'
        })]
      }, file.id);
    })]
  });
}

function RadioWidget(props) {
  const {
    options,
    value,
    required,
    disabled,
    readonly,
    autofocus,
    onChange,
    rawErrors = [],
    id,
    formContext
  } = props;
  const {
    layout = 'vertical'
  } = formContext;
  const enumOptions = getEnumOptions(props);
  const {
    enumNames = [],
    enumDescriptions = [],
    enumDisabled = [],
    inline = true,
    button = false
  } = options;
  if (button) {
    return jsx("div", {
      id: id,
      children: jsx("div", {
        className: 'btn-group',
        children: enumOptions.map((option, index) => {
          const checked = option.value === value;
          const itemDisabled = enumDisabled.indexOf(option.value) != -1;
          const label = enumNames[index] || option.label;
          return jsx(Button, {
            variant: 'outline-primary',
            onClick: () => onChange(option.value),
            active: checked,
            disabled: disabled || itemDisabled || readonly,
            children: label
          }, `${id}_${index}`);
        })
      })
    });
  }
  return jsx(Container$1, {
    id: id,
    "$inline": layout === 'horizontal' && inline,
    children: enumOptions.map((option, index) => {
      const checked = option.value === value;
      const itemDisabled = enumDisabled.indexOf(option.value) != -1;
      const label = enumNames[index] || option.label;
      const description = enumDescriptions[index];
      return jsxs(Form.Check, {
        type: 'radio',
        inline: inline,
        id: `${id}_${index}`,
        label: label,
        children: [jsx(Form.Check.Input, {
          autoFocus: autofocus && index === 0,
          onChange: () => onChange(option.value),
          disabled: disabled || itemDisabled || readonly,
          required: required,
          checked: checked,
          type: 'radio',
          isInvalid: rawErrors.length > 0
        }), jsx(Form.Check.Label, {
          children: label
        }), description && !inline && jsx(Form.Text, {
          className: 'mb-2',
          muted: true,
          as: 'div',
          dangerouslySetInnerHTML: {
            __html: description
          }
        })]
      }, `${id}_${index}`);
    })
  });
}
const Container$1 = styled.div`
  ${props => props.$inline && css`
    padding: calc(.375em + 1px) 0;

    .form-check {
      margin-bottom: 0;
    }
  `};
`;

function AvatarWidget(props) {
  const {
    options,
    disabled,
    value,
    onChange,
    rawErrors = [],
    placeholder
  } = props;
  const {
    onUpload,
    as
  } = options;
  const fileRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const handleFileChange = useCallback(async _ref => {
    let {
      target
    } = _ref;
    if (target.files) {
      setUploading(true);
      try {
        const files = Array.from(target.files).slice(0, 1);
        if (onUpload) {
          for (const file of files) {
            try {
              const result = await onUpload(file);
              onChange(result);
            } catch (e) {
              console.error(e);
            }
          }
        }
      } finally {
        setUploading(false);
      }
    }
    target.value = '';
  }, [onUpload]);
  const className = [];
  rawErrors.length > 0 && className.push('is-invalid');
  const src = value || placeholder;
  return jsx("div", {
    className: className.join(' '),
    children: jsxs(Container, {
      as: as,
      className: 'border border-1 rounded-3',
      children: [src ? jsx("img", {
        src: src
      }) : jsx("div", {
        className: 'w-100 h-100 d-flex align-items-center justify-content-center text-muted',
        children: jsx(SvgUpload, {
          height: 30,
          width: 30
        })
      }), !disabled && jsx(Mask, {
        onClick: () => fileRef.current?.click(),
        "$show": uploading,
        children: uploading ? jsx("div", {
          style: {
            width: 30,
            height: 30
          },
          className: 'spinner-border',
          role: 'status',
          children: jsx("span", {
            className: 'visually-hidden',
            children: "Loading..."
          })
        }) : jsx(SvgUpload, {
          height: 30,
          width: 30
        })
      }), jsx("input", {
        onChange: handleFileChange,
        accept: 'image/*',
        ref: fileRef,
        type: 'file',
        hidden: true
      })]
    })
  });
}
const Mask = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: none;
    justify-content: center;
    align-items: center;
    color: #FFFFFF;

    ${props => props.$show && css`
        display: flex;
    `}
`;
const Container = styled.div`
    width: 78px;
    height: 78px;
    position: relative;
    overflow: hidden;
    cursor: pointer;

    .is-invalid & {
        border-color: var(--bs-danger) !important;
    }

    img {
        width: 100%;
        height: 100%;
    }

    &:hover {
        ${Mask} {
            display: flex;
        }
    }
`;

const registry = utils.getDefaultRegistry();
const LazyTypeaheadWidget = React__default.lazy(() => import('./typeahead-widget-3196ff45.js'));
const TypeaheadWidget = props => {
  return jsx(React__default.Suspense, {
    fallback: null,
    children: jsx(LazyTypeaheadWidget, {
      ...props
    })
  });
};
const LazyDateTimeWidget = React__default.lazy(() => import('./date-time-widget-8aae558a.js'));
const DateTimeWidget = props => {
  return jsx(React__default.Suspense, {
    fallback: null,
    children: jsx(LazyDateTimeWidget, {
      ...props
    })
  });
};
const LazyDateWidget = React__default.lazy(() => import('./date-widget-4f99ae23.js'));
const DateWidget = props => {
  return jsx(React__default.Suspense, {
    fallback: null,
    children: jsx(LazyDateWidget, {
      ...props
    })
  });
};
const LazyDateRangeWidget = React__default.lazy(() => import('./date-range-widget-215561b4.js'));
const DateRangeWidget = props => {
  return jsx(React__default.Suspense, {
    fallback: null,
    children: jsx(LazyDateRangeWidget, {
      ...props
    })
  });
};
const widgets = {
  ...registry.widgets,
  BaseInput,
  TextareaWidget,
  CheckboxWidget,
  CheckboxesWidget,
  RadioWidget,
  SelectWidget,
  DateTimeWidget,
  DateWidget,
  'time': TimeWidget,
  'date-range': DateRangeWidget,
  upload: UploadWidget,
  avatar: AvatarWidget,
  typeahead: TypeaheadWidget
};

function getRegistry() {
  return {
    fields: fields,
    widgets: widgets
  };
}

const Theme = {
  className: 'row g-3',
  FieldTemplate,
  ObjectFieldTemplate,
  ArrayFieldTemplate,
  ErrorList,
  ...getRegistry()
};
const ThemeForm = withTheme(Theme);
const JsonForm = forwardRef((_ref, ref) => {
  let {
    onSubmit,
    onError,
    children,
    ...props
  } = _ref;
  const formRef = useRef();
  const callbackRef = useRef();
  useImperativeHandle(ref, () => ({
    submit() {
      formRef.current.formElement.dispatchEvent(new CustomEvent('submit', {
        bubbles: true,
        cancelable: true
      }));
      return new Promise((resolve, reject) => {
        callbackRef.current = {
          resolve,
          reject
        };
      });
    }
  }));
  const handleSubmit = useCallback(async (e, nativeEvent) => {
    try {
      let result = undefined;
      if (onSubmit) {
        result = await onSubmit(e, nativeEvent);
      }
      callbackRef.current?.resolve(result);
    } catch (e) {
      callbackRef.current?.reject(e);
    } finally {
      callbackRef.current = undefined;
    }
  }, [callbackRef, onSubmit]);
  const handleError = useCallback(e => {
    try {
      if (onError) {
        onError(e);
      }
    } finally {
      callbackRef.current?.reject(e);
      callbackRef.current = undefined;
    }
  }, [callbackRef, onError]);
  return jsx(ThemeForm, {
    ref: formRef,
    noHtml5Validate: true,
    onSubmit: handleSubmit,
    onError: handleError,
    ...props,
    children: children || jsx("input", {
      type: 'submit',
      style: {
        display: 'none'
      }
    })
  });
});
var jsonForm = memo(JsonForm, isEqual);

export { Container$2 as C, Picker as P, getRegistry as a, getEnumOptions as g, jsonForm as j, processValue as p };
